/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const challengeRefSchema = z.object({
  id: z.number(),
  title: z.string(),
});

const collectionRefSchema = z.object({
  id: z.number(),
  title: z.string(),
  parent: z
    .object({
      id: z.number(),
      title: z.string(),
    })
    .nullable(),
});

export const reviewerRecentRowV2Schema = z.object({
  id: z.number(),
  clipId: z.number(),
  action: z.string(),
  rejectionReason: z.string().nullable(),
  decisionMs: z.number().nullable(),
  createdAt: z.number(),
  challenge: challengeRefSchema.nullable(),
  collection: collectionRefSchema.nullable(),
});

export const listReviewerPerformanceRecentV2DataSchema = z.object({
  userId: z.string(),
  rows: z.array(reviewerRecentRowV2Schema),
  total: z.number(),
});

export type IReviewerRecentRowV2 = z.infer<typeof reviewerRecentRowV2Schema>;
export type IListReviewerPerformanceRecentV2Data = z.infer<
  typeof listReviewerPerformanceRecentV2DataSchema
>;

export const listReviewerPerformanceRecentV2ResponseSchema = createApiResponseSchema(
  listReviewerPerformanceRecentV2DataSchema,
) as z.ZodSchema<IAPI<IListReviewerPerformanceRecentV2Data>>;

export type IListReviewerPerformanceRecentV2Response = IAPI<IListReviewerPerformanceRecentV2Data>;
